// extracted by mini-css-extract-plugin
export var printerCard = "_hu-1";
export var printerCardConfigured = "_hu-2";
export var printerCardError = "_hu-3";
export var printerCardsContainer = "_hu-0";
export var printerIcon = "_hu-8";
export var printerIconConfigured = "_hu-5";
export var printerIconContainer = "_hu-4";
export var printerIconError = "_hu-6";
export var printerIconUnconfigured = "_hu-7";
export var workstationsTableCard = "_hu-9";